import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "eoc-relative" }


export default /*@__PURE__*/_defineComponent({
  __name: 'EOCButton',
  props: {
    text: {}
  },
  setup(__props: any) {

/**
 * End-of-content button.
 *
 * Shows fade and a button to go to billing page.
 */


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "eoc-fade" }, null, -1)),
    _createVNode(_component_router_link, {
      to: { name: 'billing' },
      class: "btns eoc-button"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.text), 1)
      ]),
      _: 1
    })
  ]))
}
}

})